(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["taku-calendar-feed"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-tb-event-feed]';
  const format = (date, options) => new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', ...options }).format(date);
  const node = (tag, className, value) => { const el = document.createElement(tag); el.className = className; if (value != null) el.textContent = value; return el; };
  const icon = type => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
    const paths = {
      concierto: ['M9 18V5l12-2v13', 'M9 6l12-2', 'M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0', 'M21 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0'],
      procesion: ['M12 2v20', 'M5 9h14'],
      procesional: ['M12 2v20', 'M5 9h14'],
      ensayo: ['M12 3 4 20h16L12 3Z', 'M12 8v6', 'M10 16h4'],
      actuacion: ['M4 5h16v16H4z', 'M4 10h16', 'M8 2v6', 'M16 2v6'],
      convivencia: ['M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', 'M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8', 'M20 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
      evento: ['M4 5h16v16H4z', 'M4 10h16', 'M8 2v6', 'M16 2v6']
    };
    for (const d of (paths[type] || paths.evento)) { const p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', d); svg.append(p); }
    return svg;
  };
  const classify = summary => {
    const value = summary.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    if (/convivencia|convivio/.test(value)) return ['convivencia', 'Convivencia'];
    if (/ensayo|formacion|clase|taller/.test(value)) return ['ensayo', 'Ensayo'];
    if (/concierto|certamen|recital|festival/.test(value)) return ['concierto', 'Concierto'];
    if (/salida|procesion|via crucis|semana santa|cofradia|estacion de penitencia/.test(value)) return ['procesional', 'Salida Procesional'];
    if (/actuacion|pasacalles|desfile/.test(value)) return ['actuacion', 'Actuación'];
    if (/evento|jornada|acto|presentacion|charla|celebracion|inauguracion|actividad/.test(value)) return ['evento', 'Evento'];
    return ['evento', 'Evento'];
  };
  const eventImage = (event, root, type) => {
    const fallbacks = { concierto: root.dataset.concertImage, ensayo: root.dataset.rehearsalImage, actuacion: root.dataset.performanceImage, evento: root.dataset.eventImage, convivencia: root.dataset.communityImage, procesional: root.dataset.processionalImage };
    const fallback = fallbacks[type] || root.dataset.image;184

    const attached = (event.attachments || []).find(item => item.mimeType?.startsWith('image/') && (item.fileId || item.fileUrl));
    if (attached) return { src: 'https://drive.google.com/thumbnail?id=' + encodeURIComponent(attached.fileId || attached.fileUrl.match(/(?:\/d\/|[?&]id=)([^/?&]+)/)?.[1] || '') + '&sz=w1600', fallback, illustrative: false };
    const description = (event.description || '').replace(/&amp;/g, '&');
    const labelled = description.match(/(?:imagen|foto|image)\s*:\s*(https:\/\/[^\s<>"']+)/i)?.[1];
    const linked = (description.match(/https:\/\/[^\s<>"']+/g) || []).find(value => /\.(?:avif|jpe?g|png|webp)(?:[?#]|$)/i.test(value));
    const driveUrl = description.match(/https:\/\/drive\.google\.com\/(?:file\/d\/|open\?id=)([^/?&\s]+)/i);
    if (driveUrl) return { src: 'https://drive.google.com/thumbnail?id=' + encodeURIComponent(driveUrl[1]) + '&sz=w1600', fallback, illustrative: false };
    const candidate = (labelled || linked || '').replace(/[),.;]+$/, '');
    try { if (new URL(candidate).protocol === 'https:') return { src: candidate, fallback, illustrative: false }; } catch (_) {}
    return { src: fallback, fallback, illustrative: true };
  };
  const makeImage = (event, root, type, className) => {
    const source = eventImage(event, root, type);
    const image = node('img', className); image.src = source.src; image.alt = source.illustrative ? root.dataset.illustrativeLabel : '';
    image.loading = 'lazy'; image.referrerPolicy = 'no-referrer'; image.width = 1800; image.height = 900;
    image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
    image.addEventListener('error', () => { if (image.src !== source.fallback) { image.src = source.fallback; image.alt = root.dataset.illustrativeLabel; } else image.classList.add('is-loaded'); });
    if (image.complete && image.naturalWidth > 0) image.classList.add('is-loaded');
    return { image, illustrative: source.illustrative };
  };
  let disclosureCount = 0;
  const eventDescription = value => {
    if (!value) return '';
    const parsed = new DOMParser().parseFromString(String(value), 'text/html');
    parsed.querySelectorAll('script,style,iframe,object').forEach(el => el.remove());
    parsed.querySelectorAll('br').forEach(el => el.replaceWith(parsed.createTextNode('\n')));
    parsed.querySelectorAll('p,div,li').forEach(el => el.append(parsed.createTextNode('\n')));
    return (parsed.body.textContent || '').replace(/(?:imagen|foto|image)\s*:\s*https?:\/\/[^\s]+/gi, '').replace(/https?:\/\/drive\.google\.com\/[^\s<>"']+/gi, '').replace(/https?:\/\/[^\s<>"']+\.(?:avif|jpe?g|png|webp)(?:\?[^\s<>"']*)?/gi, '').replace(/\n[ \t]*\n[ \t]*\n/g, '\n\n').trim();
  };
  const eventSchedule = (event, allDay) => {
    const start = new Date(allDay ? event.start.date + 'T12:00:00Z' : event.start.dateTime);
    const end = new Date(allDay ? new Date(event.end.date + 'T12:00:00Z').getTime() - 86400000 : event.end.dateTime);
    const dateKey = value => format(value, { year: 'numeric', month: '2-digit', day: '2-digit' });
    if (allDay) return 'Todo el día';
    const startTime = format(start, { hour: '2-digit', minute: '2-digit' });
    const endTime = format(end, { hour: '2-digit', minute: '2-digit' });
    if (dateKey(start) === dateKey(end)) return format(start, { weekday: 'long' }) + ' · ' + startTime + '–' + endTime + ' h';
    return format(start, { weekday: 'long', day: 'numeric', month: 'short' }) + ' ' + startTime + ' – ' + format(end, { weekday: 'long', day: 'numeric', month: 'short' }) + ' ' + endTime + ' h';
  };
  const calendarTimestamp = value => new Date(value).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  const googleCalendarUrl = event => {
    const allDay = Boolean(event.start.date);
    const start = allDay ? event.start.date.replace(/-/g, '') : calendarTimestamp(event.start.dateTime);
    const end = allDay ? event.end.date.replace(/-/g, '') : calendarTimestamp(event.end.dateTime);
    const url = new URL('https://calendar.google.com/calendar/render');
    url.searchParams.set('action', 'TEMPLATE');
    url.searchParams.set('text', event.summary || 'Actuación del Gran Poder de Granada');
    url.searchParams.set('dates', start + '/' + end);
    url.searchParams.set('ctz', 'Europe/Madrid');
    const description = eventDescription(event.description);
    if (description) url.searchParams.set('details', description);
    if (event.location) url.searchParams.set('location', event.location);
    return url.toString();
  };
  const animateDisclosure = (trigger, panel, item, opening) => {
    const itemHeight = item.getBoundingClientRect().height;
    const layoutSelector = '.tb-event-image,.tb-event-info,.tb-agenda-row-image,.tb-agenda-row-date,.tb-agenda-row-content,.tb-agenda-row-arrow';
    const movingElements = Array.from(item.querySelectorAll(layoutSelector));
    const beforeRects = new Map(movingElements.map(element => [element, element.getBoundingClientRect()]));
    item.getAnimations().forEach(animation => animation.cancel());
    movingElements.forEach(element => element.getAnimations().forEach(animation => animation.cancel()));
    panel.getAnimations().forEach(animation => animation.cancel());
    item.style.removeProperty('box-sizing');
    item.style.removeProperty('height');
    item.style.removeProperty('overflow');
    trigger.setAttribute('aria-expanded', String(opening));
    item.querySelector('.tb-event-link,.tb-agenda-row').dataset.expanded = String(opening);
    item.classList.toggle('is-expanded', opening);
    panel.hidden = !opening;
    panel.toggleAttribute('inert', !opening);
    const targetHeight = item.getBoundingClientRect().height;
    const afterRects = new Map(movingElements.map(element => [element, element.getBoundingClientRect()]));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || Math.abs(targetHeight - itemHeight) < 1) return;
    if (!opening) panel.hidden = false;
    const options = { duration: 320, easing: 'cubic-bezier(.22,.85,.3,1)' };
    item.style.boxSizing = 'border-box';
    item.style.overflow = 'hidden';
    const sizeAnimation = item.animate([
      { height: itemHeight + 'px' },
      { height: targetHeight + 'px' }
    ], options);
    sizeAnimation.onfinish = () => {
      if (trigger.getAttribute('aria-expanded') !== String(opening)) return;
      panel.hidden = !opening;
      panel.toggleAttribute('inert', !opening);
      item.style.removeProperty('box-sizing');
      item.style.removeProperty('height');
      item.style.removeProperty('overflow');
      sizeAnimation.cancel();
    };
    if (!reducedMotion) {
      movingElements.forEach(element => {
        const before = beforeRects.get(element);
        const after = afterRects.get(element);
        if (!before || !after || !before.width || !before.height || !after.width || !after.height) return;
        const dx = before.left - after.left;
        const dy = before.top - after.top;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1 && element.classList.contains('tb-agenda-row-content')) return;
        const isImage = element.matches('img');
        const transform = isImage
          ? `translate(${dx}px, ${dy}px) scale(${before.width / after.width}, ${before.height / after.height})`
          : `translate(${dx}px, ${dy}px)`;
        const motion = element.animate([
          { transformOrigin: 'top left', transform, opacity: isImage ? 1 : 0.72 },
          { transformOrigin: 'top left', transform: 'translate(0, 0)', opacity: 1 }
        ], options);
        motion.onfinish = () => motion.cancel();
      });
    }
    if (!opening) {
      const fade = panel.animate([{ opacity: 1 }, { opacity: 0 }], options);
      fade.onfinish = () => fade.cancel();
    } else {
      const fade = panel.animate([{ opacity: 0 }, { opacity: 1 }], options);
      fade.onfinish = () => fade.cancel();
    }
  };
  const eventMapLinks = event => {
    const doc = new DOMParser().parseFromString(String(event.description || ''), 'text/html');
    doc.querySelectorAll('script,style,iframe,object').forEach(el => el.remove());
    const candidates = Array.from(doc.querySelectorAll('a[href]'), link => link.getAttribute('href'));
    const text = eventDescription(event.description) + ' ' + (event.location || '');
    candidates.push(...(text.match(/https?:\/\/[^\s<>"']+/gi) || []));
    const links = new Set();
    candidates.forEach(value => {
      try {
        const url = new URL(value.replace(/[).;]+$/, ''));
        if (url.protocol !== 'https:' || url.username || url.password || url.port) return;
        const host = url.hostname.toLowerCase();
        const googleDomains = new Set(['google.com', 'google.es', 'google.co.uk', 'google.fr', 'google.de', 'google.it', 'google.pt', 'google.com.mx', 'google.com.ar', 'google.cl', 'google.com.co', 'google.com.br']);
        const rootHost = host.replace(/^(?:www\.|maps\.)/, '');
        const mapsPath = /^\/maps(?:\/|$)/.test(url.pathname);
        const googleMaps = host === 'maps.app.goo.gl' || (host === 'goo.gl' && mapsPath) || (googleDomains.has(rootHost) && (host.startsWith('maps.') || mapsPath));
        if (googleMaps) links.add(url.href);
      } catch (_) { /* Ignore text that is not a valid Maps URL. */ }
    });
    const address = String(event.location || '').trim();
    if (!links.size && address && !/https?:\/\/|^(?:por confirmar|pendiente|sin direcci[oó]n|online|virtual)$/i.test(address)) {
      const directions = new URL('https://www.google.com/maps/dir/');
      directions.searchParams.set('api', '1');
      directions.searchParams.set('destination', address);
      links.add(directions.href);
    }
    return Array.from(links);
  };
  const disclosure = (item, summary, event, root, extraClass) => {
    const trigger = node('button', 'tb-event-view-event', root.dataset.viewEvent || 'Ver detalles');
    const topActions = node('span', 'tb-event-top-actions');
    topActions.append(trigger);
    const mapLinks = eventMapLinks(event);
    let copy = eventDescription(event.description);
    mapLinks.forEach(url => { copy = copy.split(url).join(''); });
    copy = copy.trim();
    const panel = node('div', extraClass);
    panel.id = 'tb-event-extra-' + (++disclosureCount);
    panel.hidden = true;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', event.summary || 'Información del evento');
    if (copy) panel.append(node('p', 'tb-event-extra-copy', copy));
    if (mapLinks.length) {
      const mapActions = topActions;
      mapLinks.forEach((url, index) => {
        const mapLink = node('a', 'tb-event-map-link', index ? 'Cómo llegar · ' + (index + 1) : 'Cómo llegar');
        mapLink.href = url;
        mapLink.target = '_blank';
        mapLink.rel = 'noopener noreferrer';
        mapLink.setAttribute('aria-label', 'Cómo llegar: abrir en Google Maps');
        mapActions.append(mapLink);
      });

    }
    const actions = node('div', 'tb-event-calendar-actions');
    const reminder = node('a', 'tb-event-reminder', 'Añadir al calendario');
    reminder.href = googleCalendarUrl(event);
    reminder.target = '_blank';
    reminder.rel = 'noopener noreferrer';
    reminder.title = 'Abrir en Google Calendar';
    actions.append(reminder);

    trigger.type = 'button';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', panel.id);
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      if (!expanded) {
        root.querySelectorAll('[aria-expanded="true"][aria-controls]').forEach(openTrigger => {
          if (openTrigger === trigger) return;
          const openPanel = document.getElementById(openTrigger.getAttribute('aria-controls'));
          const openItem = openTrigger.closest('.tb-event-item,.tb-agenda-item');
          if (openPanel && openItem) animateDisclosure(openTrigger, openPanel, openItem, false);
        });
      }
      animateDisclosure(trigger, panel, item, !expanded);
    });
    summary.querySelector('.tb-event-info,.tb-agenda-row-content').append(topActions);
    summary.addEventListener('click', click => {
      if (!click.target.closest('a,button')) trigger.click();
    });
    item.append(summary, actions, panel);
    return Boolean(copy || mapLinks.length);
  };
  const build = (event, root) => {
    const allDay = Boolean(event.start.date);
    const start = new Date(allDay ? event.start.date + 'T12:00:00Z' : event.start.dateTime);
    if (Number.isNaN(start.getTime())) return null;
    const [type, typeLabel] = classify(event.summary);
    const item = node('article', 'tb-event-item');
    const copy = eventDescription(event.description);
    const link = node('div', 'tb-event-link');
    const imageSource = makeImage(event, root, type, 'tb-event-image');
    const media = node('span', 'tb-event-media'); media.append(imageSource.image);
    const date = node('span', 'tb-event-date');
    const day = format(start, { day: '2-digit', timeZone: allDay ? 'UTC' : 'Europe/Madrid' });
    const month = format(start, { month: 'short', timeZone: allDay ? 'UTC' : 'Europe/Madrid' }).replace('.', '');
    date.append(node('span', 'tb-event-date-day', day), node('span', 'tb-event-date-month', month));
    const info = node('span', 'tb-event-info');
    const meta = node('span', 'tb-event-meta'); meta.append(node('span', 'tb-event-mobile-date', day + ' ' + month), icon(type), node('span', 'tb-event-type', typeLabel));
    const cleanTitle = event.summary.replace(new RegExp('^' + typeLabel + '\\s*[:·-]\\s*', 'i'), '').trim() || event.summary;
    const title = node('span', 'tb-event-title', cleanTitle);
    const details = [eventSchedule(event, allDay), event.location].filter(Boolean).join(' · ');
    if (root.dataset.view === 'full') info.append(node('span', 'tb-event-feature-label', root.dataset.featuredLabel));
    info.append(meta, title, node('span', 'tb-event-detail', details));
    link.append(media, date, info);
    if (copy) link.append(node('span', 'tb-event-arrow', '↓'));
    disclosure(item, link, event, root, 'tb-event-extra');
    cardEvents.set(item, event);
    refreshBadge(item, event, root);
    return item;
  };
  const buildRow = (event, root) => {
    const allDay = Boolean(event.start.date);
    const start = new Date(allDay ? event.start.date + 'T12:00:00Z' : event.start.dateTime);
    if (Number.isNaN(start.getTime())) return null;
    const [type, label] = classify(event.summary);
    const zone = allDay ? 'UTC' : 'Europe/Madrid';
    const day = format(start, { day: '2-digit', timeZone: zone });
    const month = format(start, { month: 'short', timeZone: zone }).replace('.', '');
    const title = event.summary.replace(new RegExp('^' + label + '\\s*[:·-]\\s*', 'i'), '').trim() || event.summary;
    const detail = [eventSchedule(event, allDay), event.location].filter(Boolean).join(' · ');
    const item = node('article', 'tb-agenda-item');
    const link = node('div', 'tb-agenda-row');
    const date = node('span', 'tb-agenda-row-date'); date.append(node('strong', '', day), node('small', '', month));
    const media = makeImage(event, root, type, 'tb-agenda-row-image');
    const mediaColumn = node('span', 'tb-agenda-row-media'); mediaColumn.append(date, media.image);
    const body = node('span', 'tb-agenda-row-content'); const kind = node('span', 'tb-agenda-row-type'); kind.append(icon(type), node('span', '', label));
    body.append(kind, node('span', 'tb-agenda-row-title', title), node('span', 'tb-agenda-row-detail', detail));
    link.append(mediaColumn, body);
    link.append(node('span', 'tb-agenda-row-arrow', '↓'));
    disclosure(item, link, event, root, 'tb-agenda-extra');
    cardEvents.set(item, event);
    refreshBadge(item, event, root);
    return item;
  };
  const madridDay = value => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(value));
  const eventState = (event, now = Date.now()) => {
    if (event.start.date) {
      const today = madridDay(now);
      if (today >= event.end.date) return 'finished';
      return today >= event.start.date ? 'live' : 'upcoming';
    }
    const start = Date.parse(event.start.dateTime);
    const end = Date.parse(event.end.dateTime);
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'upcoming';
    if (now >= end) return 'finished';
    if (now >= start) return 'live';
    return madridDay(start) === madridDay(now) ? 'today' : 'upcoming';
  };
  const cardEvents = new WeakMap();
  const refreshBadge = (item, event, root) => {
    const state = eventState(event);
    if (item.dataset.eventState === state) return state;
    item.dataset.eventState = state;
    let badge = item.querySelector('.tb-event-status');
    if (!badge) {
      badge = node('span', 'tb-event-status');
      badge.setAttribute('role', 'status');
      badge.setAttribute('aria-live', 'polite');
      const dot = node('span', 'tb-event-status-dot');
      dot.setAttribute('aria-hidden', 'true');
      badge.append(dot, node('span', 'tb-event-status-label'));
      item.querySelector('.tb-event-meta,.tb-agenda-row-type').append(badge);
    }
    const labels = { live: root.dataset.liveLabel, today: root.dataset.todayLabel, upcoming: root.closest('.tnx')?.dataset.upcomingLabel || root.dataset.nextLabel, finished: root.dataset.finishedLabel };
    badge.querySelector('.tb-event-status-label').textContent = labels[state];
    return state;
  };
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const status = root.querySelector('[data-event-status]');
    const list = root.querySelector('[data-event-list]');
    const fullView = root.dataset.view === 'full';
    const followup = root.querySelector('[data-event-followup]');
    const upcoming = root.querySelector('[data-event-upcoming]');
    const more = root.querySelector('[data-event-upcoming-list]');
    const count = root.querySelector('[data-event-count]');
    let inFlight = false;
    let lastSuccess = 0;
    const load = async () => {
      if (inFlight) return;
      inFlight = true;
      if (!lastSuccess) {
        root.dataset.loading = 'true';
        root.setAttribute('aria-busy', 'true');
        status.hidden = false;
      }
      try {
        const url = new URL('https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(root.dataset.calendarId) + '/events');
        url.search = new URLSearchParams({ singleEvents: 'true', orderBy: 'startTime', timeMin: new Date().toISOString(), maxResults: String(Math.min(100, (Number(root.dataset.limit) || 8) * 2)), showDeleted: 'false' }).toString();
        const response = await fetch(url, { headers: { 'X-Goog-Api-Key': root.dataset.apiKey }, signal: AbortSignal.timeout(12000), cache: 'no-store' });
        if (!response.ok) throw new Error('Calendar ' + response.status);
        const data = await response.json();
        const events = (data.items || []).filter(event => event.status !== 'cancelled' && event.summary && event.start && event.end && eventState(event) !== 'finished').slice(0, Number(root.dataset.limit) || 8);
        const cards = document.createDocumentFragment();
        if (fullView) {
          if (events.length) { const card = build(events[0], root); if (card) cards.append(card); }
          const rows = document.createDocumentFragment();
          for (const event of events.slice(1)) { const row = buildRow(event, root); if (row) rows.append(row); }
          list.replaceChildren(cards);
          if (more) more.replaceChildren(rows);
          if (upcoming) upcoming.hidden = !more?.children.length;
          if (count) count.textContent = String(more?.children.length || 0).padStart(2, '0');
          if (followup) followup.hidden = !more?.children.length;
        } else {
          for (const event of events) { const card = build(event, root); if (card) cards.append(card); }
          list.replaceChildren(cards);
        }
        lastSuccess = Date.now();
        if (list.children.length) status.hidden = true;
        else { status.textContent = root.dataset.emptyCopy; status.hidden = false; }
      } catch (_) {
        if (!lastSuccess) {
          status.textContent = '';
          const a = node('a', '', root.dataset.openCalendar + ' ↗'); a.href = root.dataset.calendarUrl; a.target = '_blank'; a.rel = 'noopener noreferrer'; status.append(a);
          status.hidden = false;
        }
      } finally {
        inFlight = false;
        root.dataset.loading = 'false';
        root.removeAttribute('aria-busy');
      }
    };
    const refreshStatuses = () => {
      let finished = false;
      root.querySelectorAll('.tb-event-item,.tb-agenda-item').forEach(item => {
        const event = cardEvents.get(item);
        if (event && refreshBadge(item, event, root) === 'finished') finished = true;
      });
      if (finished && !inFlight) load();
    };
    const onVisibilityChange = () => {
      if (!document.hidden) refreshStatuses();
      if (!document.hidden && Date.now() - lastSuccess > 5 * 60 * 1000) load();
    };
    const timer = window.setInterval(() => { if (!document.hidden) load(); }, 15 * 60 * 1000);
    const stateTimer = window.setInterval(() => { if (!document.hidden) refreshStatuses(); }, 15000);
    document.addEventListener('visibilitychange', onVisibilityChange);
    root._tbCalendarCleanup = () => { window.clearInterval(timer); window.clearInterval(stateTimer); document.removeEventListener('visibilitychange', onVisibilityChange); };
    load();
  };
  const scan = parent => { if (parent.matches?.(selector)) init(parent); parent.querySelectorAll(selector).forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true }); else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const roots = [];
    if (event.target.matches?.(selector)) roots.push(event.target);
    roots.push(...event.target.querySelectorAll(selector));
    roots.forEach(root => root._tbCalendarCleanup?.());
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taku-disclosure-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const classify = (details) => {
      const content = Array.from(details.children).filter((child) => child.tagName !== 'SUMMARY');
      const overlay = content.some((child) => ['absolute', 'fixed'].includes(getComputedStyle(child).position));
      details.classList.toggle('tb-disclosure-overlay', overlay);
    };

    const scan = (root) => {
      if (!(root instanceof Element) && root !== document) return;
      if (root.matches?.('details')) classify(root);
      root.querySelectorAll('details').forEach(classify);
    };

    const start = () => {
      scan(document);
      document.addEventListener('click', (event) => {
        const summary = event.target.closest?.('summary');
        if (summary?.parentElement.matches('details')) classify(summary.parentElement);
      }, true);
      document.addEventListener('toggle', (event) => {
        if (event.target.matches?.('details')) classify(event.target);
      }, true);
      new MutationObserver((records) => {
        const roots = new Set();
        records.forEach((record) => {
          if (record.target instanceof Element) {
            const details = record.target.closest('details');
            if (details) roots.add(details);
          }
          record.addedNodes.forEach((node) => roots.add(node));
        });
        roots.forEach(scan);
      }).observe(document.body, { childList: true, subtree: true });
      let pending = false;
      window.addEventListener('resize', () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          scan(document);
          pending = false;
        });
      }, { passive: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taku-system"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
  const qs = (root, selector) => root.querySelector(selector);
  const qsa = (root, selector) => [...root.querySelectorAll(selector)];
  const safeUrl = value => { const url = new URL(value, location.href); if (url.origin !== location.origin) throw new Error('Invalid catalog origin'); return url; };
  async function initCatalog(root) {
   if (root.dataset.initialized) return;
   root.dataset.initialized = 'true';
   const home = root.dataset.home === 'true';
   const event = root.dataset.kind === 'taku_event';
   const list = qs(root, '[data-tb-items]');
   const search = qs(root, '[data-tb-search]');
   const result = qs(root, '[data-tb-result]');
   const noResults = qs(root, '[data-tb-no-results]');
   const filters = qsa(root, '[data-tb-filter]');
   let items = qsa(list, '[data-tb-item]');
   let next = qs(root, '[data-tb-next]');
   let period = new URL(location.href).searchParams.get('period') || 'upcoming';
   if (!['upcoming', 'archive', 'all'].includes(period)) period = 'upcoming';
   let loading = false;
   let failed = false;
   const params = new URL(location.href).searchParams;
   if (search) search.value = params.get('q') || '';
   function hydrateFilters() {
    const controls = qs(root, '[data-tb-filters]');
    if (controls) controls.hidden = items.length < Number(root.dataset.filterThreshold) && !next && !params.has('q');
    filters.forEach(select => {
     const name = select.dataset.tbFilter;
     const value = select.value || params.get(name) || '';
     const values = [...new Set(items.flatMap(item => (item.dataset[name] || '').split('|||')).filter(Boolean))].sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
     select.replaceChildren(new Option(select.options[0]?.text || 'Todos',''), ...values.map(value => new Option(value,value)));
     select.value = value;
     select.parentElement.hidden = values.length < 2 && !value;
    });
   }
   function apply(updateUrl = false) {
    const query = normalize(search?.value).trim();
    const terms = query.split(/\s+/).filter(Boolean);
    const matches = items.filter(item => {
     const periodMatch = !event || period === 'all' || (period === 'archive' ? item.dataset.status === 'completed' : item.dataset.status !== 'completed');
     return periodMatch && terms.every(term => normalize(item.dataset.search).includes(term)) && filters.every(select => !select.value || (item.dataset[select.dataset.tbFilter] || '').split('|||').includes(select.value));
    });
    if (event) matches.sort((a,b) => period === 'archive' ? Number(b.dataset.date)-Number(a.dataset.date) : Number(a.dataset.date)-Number(b.dataset.date));
    else if(root.dataset.kind === 'taku_milestone') matches.sort((a,b) => Number(a.dataset.date)-Number(b.dataset.date));
    else matches.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title, undefined, {sensitivity:'base'}));
    items.forEach(item => item.hidden = true);
    const visible = home ? matches.slice(0,3) : matches;
    visible.forEach(item => { item.hidden = false; list.append(item); });
    if (noResults) noResults.hidden = matches.length > 0 || !items.length || loading;
    if (result && !home) result.textContent = failed ? root.dataset.error : loading ? root.dataset.loading : items.length ? `${root.dataset.results}: ${matches.length}` : '';
    if (home && !items.length && !next) root.hidden = true;
    qsa(root,'[data-tb-period]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tbPeriod === period)));
    if (updateUrl && !home) {
     const url = new URL(location.href);
     for (const key of [...url.searchParams.keys()]) if (key === 'page' || key.startsWith('page_')) url.searchParams.delete(key);
     const set = (key,value) => value ? url.searchParams.set(key,value) : url.searchParams.delete(key);
     set('q',search?.value.trim());
     filters.forEach(select=>set(select.dataset.tbFilter,select.value));
     if(event)set('period',period === 'upcoming' ? '' : period);
     history.replaceState(null,'',url);
    }
   }
   async function loadAll() {
    if(loading || !next) return;
    loading = true; failed = false; apply();
    const visited = new Set();
    try {
     while(next) {
      const url = safeUrl(next.href);
      if(visited.has(url.href)) throw new Error('Repeated catalog page');
      visited.add(url.href);
      const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(15000)});
      if(!response.ok) throw new Error('Catalog request failed');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const remote = doc.querySelector(`[data-tb-catalog="${CSS.escape(root.dataset.tbCatalog)}"]`);
      if(!remote) throw new Error('Catalog not found');
      const existing = new Set(items.map(item=>item.dataset.id));
      const incoming = qsa(remote,'[data-tb-items] > [data-tb-item]').filter(item=>!existing.has(item.dataset.id));
      list.append(...incoming);items.push(...incoming);
      const following = qs(remote,'[data-tb-next]');
      if(following) next.href = new URL(following.getAttribute('href'),url).href;
      else { next.remove();next = null; }
      hydrateFilters();apply();
     }
    } catch(error) { failed = true; }
    finally { loading = false;apply(); }
   }
   if(next) next.addEventListener('click',event=>{event.preventDefault();loadAll();});
   search?.addEventListener('input',()=>{apply(true);loadAll();});
   filters.forEach(select=>select.addEventListener('change',()=>{apply(true);loadAll();}));
   qsa(root,'[data-tb-clear]').forEach(button=>button.addEventListener('click',()=>{if(search) search.value='';filters.forEach(select=>select.value='');period='all';apply(true);}));
   qsa(root,'[data-tb-period]').forEach(button=>button.addEventListener('click',()=>{period=button.dataset.tbPeriod;apply(true);loadAll();}));
   const tabs=qs(root,'[data-tb-event-tabs]');if(tabs)tabs.hidden=false;
   hydrateFilters();apply();
   if(next && !home) loadAll();
  }
  const escapeIcs = value => String(value || '').replace(/\\/g,'\\\\').replace(/\r?\n/g,'\\n').replace(/;/g,'\\;').replace(/,/g,'\\,');
  const utc = value => new Date(value).toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'');
  function foldIcs(line) {
   let rows=[],row='',bytes=0;
   for(const char of line) { const size=new TextEncoder().encode(char).length; if(bytes+size>73){rows.push(row);row=' ';bytes=1;} row+=char;bytes+=size; }
   rows.push(row);return rows.join('\r\n');
  }
  function boot(root=document) {
   qsa(root,'[data-tb-catalog]').forEach(initCatalog);
   qsa(root,'[data-tb-calendar]').forEach(button=>{button.hidden=!(Date.parse(button.dataset.end)>Date.parse(button.dataset.start));});
  }
  document.addEventListener('click', event => {
   const close=event.target.closest('[data-tb-close]');
   if(close){const menu=close.closest('details');menu.open=false;qs(menu,'summary').focus();}
   const play=event.target.closest('[data-tb-play]');
   if(play){const host=play.closest('[data-tb-embed]');const id=host.dataset.videoId;if(!/^[a-zA-Z0-9_-]{11}$/.test(id))return;const iframe=document.createElement('iframe');iframe.src=`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;iframe.title=host.dataset.title;iframe.allow='autoplay; encrypted-media; picture-in-picture';iframe.allowFullscreen=true;host.replaceChildren(iframe);iframe.focus();}
   const calendar=event.target.closest('[data-tb-calendar]');
   if(calendar){
    const d=calendar.dataset;
    if(!Number.isFinite(Date.parse(d.start)) || !Number.isFinite(Date.parse(d.end)) || Date.parse(d.end)<=Date.parse(d.start)) return;
    const lines=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Taku Band//Agenda//ES','CALSCALE:GREGORIAN','BEGIN:VEVENT',`UID:${escapeIcs(d.uid)}@${location.hostname}`,`DTSTAMP:${utc(new Date())}`,`DTSTART:${utc(d.start)}`,`DTEND:${utc(d.end)}`,`SUMMARY:${escapeIcs(d.title)}`,`LOCATION:${escapeIcs(d.place)}`,`URL:${escapeIcs(d.url)}`,'END:VEVENT','END:VCALENDAR'];
    const url=URL.createObjectURL(new Blob([lines.map(foldIcs).join('\r\n')+'\r\n'],{type:'text/calendar;charset=utf-8'}));const a=document.createElement('a');a.href=url;a.download='actuacion.ics';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
   }
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('[data-tb-menu][open]');if(menu){menu.open=false;qs(menu,'summary').focus();}}});
  document.addEventListener('change',event=>{if(event.target.matches('[data-tb-purpose]') && event.target.value)location.assign(safeUrl(event.target.value));});
  
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
 })();
  } catch(e) { console.error(e); }
})();

})();
